import React, { useState } from "react";

// import { useForm, ValidationError } from "@formspree/react";
// import Img
import img from "../../assets/img/common/vendor.png";
const BookYourTravel = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch(
        "https://email-nodejs-fawn.vercel.app/api/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            emailConfig: {
              host: "mail.nascentinnovations.com",
              port: 465,
              user: "zainali@nascentinnovations.com",
              pass: "zainali786",
              from: "zainali@nascentinnovations.com",
            },
            emailData: {
              to: "herezainali@gmail.com", // Updated to match the curl example
              subject: "New Travel Booking Request from House of Polani",
              text: `New booking request from: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nService: ${formData.service}\nMessage: ${formData.message}`,
              html: `
                <h2>New Travel Booking Request</h2>
                <p><strong>Name:</strong> ${formData.name}</p>
                <p><strong>Email:</strong> ${formData.email}</p>
                <p><strong>Phone:</strong> ${formData.phone}</p>
                <p><strong>Service:</strong> ${formData.service}</p>
                <p><strong>Message:</strong> ${formData.message}</p>
              `,
            },
          }),
        }
      );

      if (response.ok) {
        setSucceeded(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          service: "",
          message: "",
        });
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Failed to submit. Please try again.");
      }
    } catch (err) {
      setError("Network error. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section
        id="vendor_form_area"
        className=""
        style={{ marginBottom: "40px" }}
      >
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-12">
                    <div className="vendor_form_heading">
                        <h2>Become a vendor</h2>
                        <p>Eu sint minim tempor anim aliqua officia voluptate incididunt deserunt.
                            <br /> Velitgo quis Lorem culpa qui pariatur occaecat.
                        </p>
                    </div>
                </div> */}
            <div className="col-lg-8">
              <div className="vendor_form_heading">
                <h2>Book Your Travel Experience</h2>
                <p>
                  Transform your travel dreams into reality with House of
                  Polani. Whether you're planning a corporate trip, religious
                  pilgrimage, or leisure vacation, our expert team is ready to
                  assist you. Complete the form below, and we'll create a
                  personalized travel solution tailored to your needs.
                </p>
              </div>
              <div className="vendor_form" style={{ marginRight: "10px" }}>
                <div className="tour_booking_form_box">
                  <form
                    onSubmit={handleSubmit}
                    id="tour_bookking_form_item"
                    className=""
                  >
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control bg_input"
                            placeholder="Full Name*"
                            name="name"
                            id="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control bg_input"
                            placeholder="Email Address"
                            name="email"
                            id="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="tel"
                            className="form-control bg_input"
                            placeholder="Phone Number*"
                            name="phone"
                            id="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <select
                            className="form-control form-select bg_input"
                            name="service"
                            id="service"
                            value={formData.service}
                            onChange={handleChange}
                            required
                          >
                            <option value="" disabled>
                              Select Service
                            </option>
                            <option value="Corporate Travel">
                              Corporate Travel
                            </option>
                            <option value="E-Ticket Services">
                              E-Ticket Services
                            </option>
                            <option value="International Reservations">
                              International Reservations
                            </option>
                            <option value="Domestic Reservations">
                              Domestic Reservations
                            </option>
                            <option value="International Rail Booking">
                              International Rail Booking
                            </option>
                            <option value="Car Rental">Car Rental</option>
                            <option value="Worldwide Visa">
                              Worldwide Visa
                            </option>
                            <option value="Passport Services">
                              Passport Services
                            </option>
                            <option value="NADRA Services">
                              NADRA Services
                            </option>
                            <option value="Travel Insurance">
                              Travel Insurance
                            </option>
                            <option value="Holiday Packages">
                              Holiday Packages
                            </option>
                            <option value="Cruise Packages">
                              Cruise Packages
                            </option>
                            <option value="MICE Group Tours">
                              MICE Group Tours
                            </option>
                            <option value="Hajj Services">Hajj Services</option>
                            <option value="Umrah Services">
                              Umrah Services
                            </option>
                            <option value="Ziarat Services">
                              Ziarat Services
                            </option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group">
                          <textarea
                            className="form-control bg_input"
                            placeholder="Additional Details (Optional)"
                            name="message"
                            id="message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="4"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="booking_tour_form_submit pt-4">
                      {succeeded && (
                        <div className="col-lg-12">
                          <div
                            className="vendor_form_heading alert alert-success"
                            role="alert"
                          >
                            <h2>Thank You!</h2>
                            <p>
                              We've received your booking request. Our team will
                              contact you shortly to discuss your travel plans
                              and create a personalized solution for you.
                            </p>
                          </div>
                        </div>
                      )}
                      {error && (
                        <div className="col-lg-12">
                          <div
                            className="vendor_form_heading alert alert-danger"
                            role="alert"
                          >
                            <p>{error}</p>
                          </div>
                        </div>
                      )}
                      <button
                        type="submit"
                        className="btn btn_theme btn_md"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="vendor_img">
                <img src={img} alt="img" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookYourTravel;
